import { UtilsService } from "@/services/utils/utils.service";
import { authorizedAPI } from "@/config/axios.config";

const utils = new UtilsService();

export interface PaymentHistory {
  data: Payment[];
  total: number;
  page: number;
  limit: number;
}

export interface Payment {
  id: string;
  subscriptionId: string;
  userId: string;
  amountInCents: number;
  currency: string;
  status: string;
  invoiceNumber?: string;
  transactionId?: string;
  paymentMethod?: string;
  invoicePdfUrl?: string;
  receiptPdfUrl?: string;
  expiresAt?: string;
  paidAt?: string;
  createdAt: string;
  updatedAt: string;
  subscription?: {
    id: string;
    plan: {
      id: string;
      displayName: string;
    };
  };
}

class PaymentService {
  async getPaymentHistory(params?: {
    page?: number;
    limit?: number;
    status?: string;
  }) {
    return utils.handleApiRequest(() =>
      authorizedAPI.get("/payments/history", { params })
    );
  }

  async getPaymentById(paymentId: string) {
    return utils.handleApiRequest(() =>
      authorizedAPI.get(`/payments/${paymentId}`)
    );
  }

  async getInvoicePresignedUrl(paymentId: string) {
    return utils.handleApiRequest(() =>
      authorizedAPI.get(`/payments/${paymentId}/invoice/presigned-url`)
    );
  }

  async getReceiptPresignedUrl(paymentId: string) {
    return utils.handleApiRequest(() =>
      authorizedAPI.get(`/payments/${paymentId}/receipt/presigned-url`)
    );
  }
}

export const paymentService = new PaymentService();


